module.exports = __webpack_public_path__ + "static/img/e5.4a39645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e5.png
// module id = umJb
// module chunks = 1